import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AddImageFilledSvg = function AddImageFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.39 2.249H2v8.41c2.005 0 3.99.408 5.827 1.201a14.6 14.6 0 0 1 4.855 3.405h2.192V12.25s2.27.017 3.103 0c.832-.017 2.414 0 2.414 0zM17.42 8.402a2.3 2.3 0 0 1-1.626.665c-.61 0-1.194-.24-1.625-.665a2.26 2.26 0 0 1-.674-1.608c0-.602.242-1.18.674-1.607a2.3 2.3 0 0 1 1.625-.665c.61 0 1.195.24 1.626.665a2.26 2.26 0 0 1 .673 1.607 2.26 2.26 0 0 1-.673 1.608",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.115 20.43v-3.2l-.533-.622C9.093 13.701 5.857 12.022 2 12.022v8.409zM16.713 14.067v2.955h-2.989v2.273h2.989v2.954h2.299v-2.954H22v-2.273h-2.988v-2.955z"
  }));
};
export var AddImageFilled = function AddImageFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AddImageFilledSvg
  }));
};